<template>
  <!-- 인쇄할 때 표시 -->
  <div v-if="isPrint || readonly" class="fileupload-print print-container pb-8">
    <vs-row v-if="isShowTitle && !!sectionTitle" class="mt-6 mb-4">
      <vs-col>
        <h5><i class="dot"></i>{{ sectionTitle }}</h5>
      </vs-col>
    </vs-row>
    <ul class="grid grid-cols-2 gap-5">
      <li v-for="(file, fileIndex) of printFile" :key="file.id">
        <div class="mb-2" v-if="gridTitle && gridTitle[fileIndex - 1]">{{ gridTitle[fileIndex - 1] }}</div>
        <div
          :style="{
            backgroundImage: 'url(' + file.image.path + ')',
            backgroundPosition: 'center center',
            cursor: 'pointer',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat'
          }"
          class="upload-content__file bg-center bg-no-repeat bg-contain"
          @click="onClickImage(file.image.path)"
        ></div>
        <div class="print-input mt-2">
          {{ file.input }}
        </div>
      </li>
    </ul>
  </div>

  <!-- 작성할 때 표시 -->
  <div v-else>
    <div class="flex justify-between items-center mt-8 mb-4">
      <!-- Title -->
      <h5 v-if="isShowTitle && !!sectionTitle" class="flex items-center"><i class="dot"></i>{{ sectionTitle }}</h5>
      <div v-else></div>

      <!-- Controller -->
      <div v-if="isCheckMode && !readonly && !isPrint">
        <vs-button color="secondary" @click="handleAdd"> 사진추가 </vs-button>
        <vs-button class="ml-4" color="secondary" type="border" @click="handleRemove"> 선택삭제 </vs-button>
      </div>
    </div>

    <div class="grid grid-cols-12 h-upload gap-5" :class="isShowTitle ? '' : 'mt-6'">
      <div v-for="(file, file_i) in fileList" :key="file_i" class="upload-content" :class="'col-span-' + Math.ceil(12 / setRowCount)">
        <!-- ========== Head ========== -->
        <div class="mb-2" v-if="gridTitle && gridTitle[file_i]">{{ gridTitle[file_i] }}</div>

        <!-- ========== Image ========== -->
        <div class="upload-content__file">
          <vs-checkbox v-if="isCheckMode" v-model="file.checked" :style="'position: absolute; top: 0;'" class="mt-2 z-20" />
          <div
            class="upload-content__content"
            :style="{
              backgroundImage: `url(${!!file.image ? file.image.path : ''})`,
            }"
          >
            <img v-if="isPrint" class="w-full h-full printImg" :src="file.thumb" alt="" />
            <FileUploaderTransparent v-else v-model="file.image" @input="setFile(file_i, file.image)" :readonly="readonly" />
          </div>
        </div>

        <!-- ========== Footer ========== -->
        <div v-if="withDatePicker" class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
          <div class="col-span-6 flex items-center">
            <p v-if="isPrint" class="print-input">{{ file.input }}</p>
            <vs-input v-else v-model="file.input" :placeholder="placeholder" class="w-full flex-1"></vs-input>
          </div>
          <div class="col-span-6 flex items-center">
            <p v-if="isPrint" class="print-input">{{ file.input }}</p>
            <date-selector v-else class="w-full flex-1" v-model="file.date" :placeholder="placeHolderDatePicker" :readonly="readonly" />
          </div>
        </div>
        <div v-else class="upload-content__input mt-2">
          <div v-if="!notInput">
            <p v-if="isPrint" class="w-full">{{ file.input }}</p>
            <vs-input v-else class="w-full h-full" v-model="file.input" :placeholder="placeholder" :readonly="readonly" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateFileUploadCheckList from "@/views/modules/template/TemplateFileUploadCheckList";
import TemplateFileUploadCheckListCol from "@/views/modules/template/TemplateFileUploadCheckListCol";
import TemplateFileUploadGallery from "@/views/modules/template/TemplateFileUploadGallery";
import FileUploaderTransparent from "@/components/FileUploaderTransparent2";
import DateSelector from "@/components/selector/DateSelector";

export default {
  name: "PhotoUploadGridModule",
  components: {
    TemplateFileUploadGallery,
    TemplateFileUploadCheckListCol,
    TemplateFileUploadCheckList,
    FileUploaderTransparent,
    DateSelector,
  },
  props: {
    isCheckMode: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "check_list",
    },
    /** 이미지 업로드 그리드 개수 */
    gridCount: Number,

    /** 한 줄에 표시할 셀의 개수 (1 ~ 4) */
    rowCount: Number,

    /** 맨 위에 표시할 동그라미 제목 */
    sectionTitle: String,

    /** 파일 형식 상관없이 업로드할 수 있는 경우 TRUE */
    fileTypeAll: {
      type: Boolean,
      default: false,
    },
    withDatePicker: {
      type: Boolean,
      default: false,
    },

    /** 맨 위의 동그라미 제목 표시 여부 */
    isShowTitle: {
      type: Boolean,
      default: true,
    },

    /** 인쇄용 화면일 경우 TRUE */
    isPrint: Boolean,

    /** 입력 창에 표시할 힌트 */
    placeholder: String,

    placeHolderDatePicker: {
      type: String,
      default: "날짜선택",
    },

    readonly: Boolean,
    id: String,
    value: Array, //{ id:0, fileName:'test1.txt', fileSize:1234, path:'', thumb:'', input:'' }
    multiStage: Number,

    /** 인풋창 제거 */
    notInput: Boolean,
    /** 그리드내 타이틀 */
    gridTitle: Array,
  },
  watch: {
    value: {
      handler(value) {
        this.fileList = value;
      },
    },
    fileList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    printFile() {
      return this.fileList.filter((file) => file.id !== 0);
    },
    setRowCount() {
      if (4 < this.rowCount) return 4;
      else if (this.rowCount < 1) return 1;
      else return this.rowCount;
    },
  },
  data() {
    return {
      fileList: this.value,
      checkIndex: [],
    };
  },
  created() {
    this.fillEmptyFileList();
  },
  methods: {
    fillEmptyFileList() {
      for (let index = this.fileList.length; index < this.gridCount; index++) {
        this.fileList.push({});
      }
    },
    handleAdd() {
      this.fileList.push({});
    },
    handleRemove() {
      this.fileList = this.fileList.filter((fl) => !fl.checked);
    },
    setFile(index, file) {
      this.fileList[index].id = !!file ? file.id : null;
      this.fileList[index].path = !!file ? file.path : null;
      this.fileList[index].fileName = !!file ? file.fileName : null;
    },
    // 읽기 전용에서, 이미지가 클릭됐을 때 새 창으로 이미지 표시
    onClickImage(src) {
      window.open(src, "_blank");
    },
  },
  // mounted() {
  //   setTimeout(() => {
  //     this.isPrint = true;
  //   }, 5000);
  // }
};
</script>

<style scoped lang="scss">
.upload-content__file {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  border: 1px dashed #cdcdcd;
  border-radius: 6px;

  .upload-content__content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;

    .printImg {
      background-color: white;
      border-radius: 6px;
    }
  }
}
</style>
